import {useTranslation} from 'react-i18next'

import {usePlantConfig} from './usePlantConfig'

export const useRequiredConfig = (plantId: string) => {
  const {
    i18n: {language}
  } = useTranslation()

  const {data: config} = usePlantConfig({plantId, language})

  if (!config) {
    throw new Error('Config is not loaded')
  }

  return config
}
